import Button from 'components/ui/Button/Button';
import { useCloseModal } from 'components/remodal/v2/hooks';
import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';

const ArchiveIntroductionModal = ({ onContinue }: { onContinue: () => void }) => {
  const closeModal = useCloseModal();

  const processAction = () => {
    closeModal();
    onContinue();
  };

  return (
    <ArchiveModal>
      <h5 style={{ width: '95%' }}>Archiving messages</h5>
      <div className="container">
        <div className="right">
          <p>
            Archiving a conversation removes it from your messages list and does not affect booking status. Select the
            archive icon in your messages list to access archived conversations.
          </p>
          <div className="box">
            <img src="/images/messaging/archive-action.svg" alt="" />
          </div>
        </div>
        <div className="left">
          <p> To unarchive conversations simply tap the icon on the top right of the conversation.</p>
          <div className="box">
            <img src="/images/messaging/unarchive-action.svg" alt="" />
          </div>
        </div>
      </div>
      <Button text="Archive" onClick={processAction} variant="renter" />
    </ArchiveModal>
  );
};

const ArchiveModal = styled.div`
  h5 {
    font-weight: bold;
    font-size: 24px;
    line-height: 50px;
    color: #0a252f;
  }

  .right,
  .left {
    display: flex;
    gap: 25px;
    p {
      font-size: 16px;
      line-height: 25px;
      color: #17233c;
    }
  }

  .left {
    flex-flow: row-reverse;
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .box {
    background: #ffffff;
    box-shadow: 0px 0px 17px rgba(0, 0, 0, 0.18);
    padding: 20px;
    height: fit-content;

    ${mediaMSmMax} {
      padding: 15px;
      height: 83px;
    }

    img {
      padding: 13px;
      width: 25px;
      height: 25px;
      box-sizing: content-box;
      border-radius: 6px;
      border: 1px solid #dbdfe5;
    }
  }

  button {
    padding: 0 25px;
    ${mediaMSmMax} {
      width: 100%;
    }
  }
`;

export default ArchiveIntroductionModal;
